import { Modifiers } from "@/types";
import { bem } from "@/utilities";
import React from "react";
import ReactModal from "react-modal";

interface Props {
  children: JSX.Element | JSX.Element[];
  isOpen: boolean;
  contentClassModifiers?: Modifiers;
  onClickOverlay?: () => void;
  overrideClassName?: string;
}

export const Modal: React.FC<Props> = ({
  children,
  isOpen,
  onClickOverlay,
  contentClassModifiers,
  overrideClassName,
}) => {
  return (
    <ReactModal
      appElement={document.querySelector("#root") as HTMLElement}
      isOpen={isOpen}
      onRequestClose={() => onClickOverlay()}
      className={
        overrideClassName || bem("modal", "content", contentClassModifiers)
      }
      style={{
        overlay: {
          zIndex: 1000,
          backgroundColor: "rgba(0, 0, 0, 0.56)",
          display: "flex",
          padding: "0 32px",
        },
      }}
    >
      {children}
    </ReactModal>
  );
};
